/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  Checkbox,
  Col,
  Divider,
  Image,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
// import Slider from "react-slick";
import { MetaTags } from "react-meta-tags";
import {
  ClockCircleOutlined,
  CalendarOutlined,
  UsergroupAddOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router";
import "react-range-slider-input/dist/style.css";
// import { useDispatch } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import Logo1 from "../../assets/images/logo-dark.png";
import moment from "moment";
// import { loadPackageSingleList } from "../../store/packages/actions";
import { emailIsValid, phoneIsValid } from "../../helpers/validations";
import api, { setAuthToken } from "../../helpers";
import { toast } from "react-hot-toast";
import { travellerDetailsTabs } from "./data";
import { FaHotel } from "react-icons/fa6";
import { PiBinocularsBold } from "react-icons/pi";
import { IoCarSportSharp } from "react-icons/io5";
import { GiHotMeal } from "react-icons/gi";
import Title from "antd/es/typography/Title";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { myAccountApi } from "../../store/My-Account/actions";
import { jwtDecode } from "jwt-decode";

const TravellerDetails = (props) => {
  const media = useMedia();
  const dispatch = useDispatch();

  // const dispatch = useDispatch();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const history = useHistory();

  const packageDetailsDataId =
    props && props.location && props.location.state
      ? props.location.state.data.packageId
      : "";

  const packageSelectData =
    props && props.location && props.location.state
      ? props.location.state.data
      : "";
  // console.log(packageSelectData, "packageSelectData");
  const packageDetailsData =
    props && props.location && props.location.state
      ? props.location.state.packageData
      : "";
  const priceData =
    props && props.location && props.location.state
      ? props.location.state.priceData
      : "";

  const startDate =
    priceData && priceData.dateOfTravel
      ? moment(priceData.dateOfTravel).format("Do MMM YYYY")
      : "";
  const nights =
    packageDetailsData && packageDetailsData.nights
      ? Number(packageDetailsData.nights.replace("Nights", ""))
      : "";
  const endDate =
    priceData && priceData.dateOfTravel && packageDetailsData.nights
      ? moment(priceData.dateOfTravel).add(nights, "days").format("Do MMM YYYY")
      : "";

  // verified usesr

  const loggedUser = localStorage.getItem("loggedInUser");
  const loggedOut = localStorage.getItem("loggedOut");
  const verifiedUserDetails = loggedUser ? JSON.parse(loggedUser) : "";
  const verifiedUserData =
    verifiedUserDetails !== undefined ? verifiedUserDetails.data : "";
  const verifiedUsers =
    verifiedUserDetails !== undefined && verifiedUserData !== undefined
      ? jwtDecode(verifiedUserData.token)
      : "";

  // useEffect(() => {
  //   if (verifiedUserData !== undefined && verifiedUserData !== "") {
  //     dispatch(myAccountApi());
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  //reducer
  // const { my_account_list = [] } = useSelector((state) => state.MyAccount);

  // const userInfoDetails =
  //   my_account_list &&
  //   my_account_list.userData &&
  //   my_account_list.userData !== undefined
  //     ? my_account_list.userData
  //     : "";

  //store integrations

  // useEffect(() => {
  //   dispatch(loadPackageSingleList(packageDetailsDataId));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // const {
  //   packages_single_list = [],
  //   recordsMetaData = {},
  //   terms_single_conditions_list = [],
  //   traveller_age_restrictions = [],
  // } = useSelector((state) => state.Packages);

  // const packageDataTable =
  //   packages_single_list && packages_single_list.datum
  //     ? packages_single_list.datum
  //     : [];

  //calculate price details
  const [travellerTabs, setTravellerTabs] = useState("1. Review & Travellers");
  const [titleList, setTitleList] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileValidations, setMobileValidations] = useState(false);
  const [email, setEmail] = useState("");
  const [emailValidations, setEmailValidations] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponValidations, setCouponValidations] = useState(false);
  const [policyAccept, setPolicyAccept] = useState("");
  const [makePayment, setMakePayment] = useState("fullPayment");
  const [gstOpen, setGstOpen] = useState(false);
  const [generateOtpModal, setGenerateOtpModal] = useState(false);
  const [generateBtnDisabled, setGenerateBtnDisabled] = useState(false);
  const [verifyOtpValidations, setVerifyOtpValidations] = useState(false);
  const [verifyBtnDisabled, setVerifyBtnDisabled] = useState(false);
  const [otpGenerateValidations, setOtpGenerateValidations] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  //enquire now details
  const [gstNo, setGstNo] = useState("");
  const [address, setAddress] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerMail, setCustomerMail] = useState("");
  const [customerMobileValidations, setCustomerMobileValidations] =
    useState(false);
  const [customerEmailValidations, setCustomerEmailValidations] =
    useState(false);
  //mobile and mail validations
  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setMobile(current_value);

    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
      setMobileValidations(true);
    } else {
      document.getElementById("error-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        // setuserValue(true);
      }
      setMobileValidations(false);
    }
  };

  //Email validation changes
  const validationEmailChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-email-input");
    const current_value = inputValue.replace(/ /g, "");
    setEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-email-panel").style.display = "block";
      mainInput.value = current_value;
      setEmailValidations(true);
    } else {
      document.getElementById("error-email-panel").style.display = "none";
      setEmailValidations(false);
    }
  };

  //mobile and mail validations
  const validationEnquireChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-enquire-input");
    const current_value = inputValue.replace(/ /g, "");
    setCustomerMobile(current_value);

    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-enquire-panel").style.display = "block";
      mainInput.value = current_value;
      setCustomerMobileValidations(true);
    } else {
      document.getElementById("error-enquire-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        // setuserValue(true);
      }
      setCustomerMobileValidations(false);
    }
  };

  //Email validation changes
  const validationEnquireEmailChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-enquire-email-input");
    const current_value = inputValue.replace(/ /g, "");
    setCustomerMail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-enquire-email-panel").style.display =
        "block";
      mainInput.value = current_value;
      setCustomerEmailValidations(true);
    } else {
      document.getElementById("error-enquire-email-panel").style.display =
        "none";
      setCustomerEmailValidations(false);
    }
  };
  // console.log(roomTypeList, "roomTypeList");
  const [bookingButtonDisabled, setBookingButtonDisabled] = useState(false);
  const [couponButtonDisabled, setCouponButtonDisabled] = useState(false);
  const [couponAppliedData, setCouponAppliedData] = useState("");

  const addCouponApply = () => {
    if (couponCode !== "") {
      setCouponButtonDisabled(true);
      setTimeout(() => {
        setCouponButtonDisabled(false);
      }, 3000);
      const coupons = {
        packageId: packageDetailsDataId,
        priceEnquiryNo: priceData.priceEnquiryNo,
        couponCode: couponCode,
      };
      api
        .post("/booking/apply-coupon-code", coupons)
        .then((res) => {
          toast.success(res.data.msg);
          setCouponAppliedData(res.data.data.discountAmount);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.msg);
          toast.error(
            errorMsg || "There is an issue while booking the packages"
          );

          Promise.reject(error);
        });
    } else {
      setCouponValidations(true);
    }
  };

  const grandTotal =
    priceData &&
    priceData.finalPrice !== undefined &&
    couponAppliedData !== "" &&
    verifiedUserData !== undefined
      ? parseFloat(
          priceData.finalPrice -
            verifiedUserData.rewardPoint -
            couponAppliedData
        )
      : priceData &&
        priceData.finalPrice !== undefined &&
        couponAppliedData !== "" &&
        verifiedUserData == undefined
      ? parseFloat(priceData.finalPrice - couponAppliedData)
      : priceData &&
        priceData.finalPrice !== undefined &&
        verifiedUserData !== undefined
      ? parseFloat(priceData.finalPrice - verifiedUserData.rewardPoint)
      : priceData &&
        priceData.finalPrice !== undefined &&
        verifiedUserData === undefined
      ? parseFloat(priceData.finalPrice)
      : 0;

  // const bookingDetails = {
  //   priceEnquiryNo: priceData.priceEnquiryNo,
  //   travellersDetails: {
  //     title: titleList && titleList.value,
  //     firstName: firstName,
  //     lastName: lastName,
  //     contactDetails: {
  //       mobile: mobile,
  //       email: email,
  //     },
  //     // gstDetails: {
  //     //   mobile: "8903021003",
  //     //   email: "user@gmail.com",
  //     //   gstNo: "11909e83Z03",
  //     //   companyName: "planMyTrip",
  //     //   address: "Theni,TamilNadu",
  //     // },
  //   },
  //   paymentMethod: makePayment,
  //   couponCode: couponCode,
  // };

  const generateOtpObj = {
    mobile: mobile,
    otp: otpValue,
    travellersDetails: {
      title: titleList && titleList.value,
      firstName: firstName,
    },
  };

  // const bookingDetailsObj = Object.keys(bookingDetails).forEach(
  //   (k) =>
  //     (bookingDetails[k] === "" || bookingDetails[k] === undefined) &&
  //     delete bookingDetails[k]
  // );

  const generateOtpDetails = () => {
    if (
      titleList &&
      titleList.value !== "" &&
      firstName !== "" &&
      mobile !== ""
    ) {
      setGenerateBtnDisabled(true);
      setTimeout(() => {
        setGenerateBtnDisabled(false);
      }, 2000);
      setOtpGenerateValidations(false);
      api
        .post("/user/send-mobile-otp", {
          mobile: mobile,
        })
        .then((res) => {
          toast.success(res.data.msg);
          setGenerateOtpModal(true);
          setIsActive(true);
          setTimeLeft(30);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "There is an issue while generate the otp");
          Promise.reject(error);
        });
    } else {
      setOtpGenerateValidations(true);
    }
  };

  const verifyOtpDetails = () => {
    if (otpValue !== "") {
      setVerifyOtpValidations(false);
      setVerifyBtnDisabled(true);
      setTimeout(() => {
        setVerifyBtnDisabled(false);
      }, 3000);
      api
        .post("/user/verify-mobile-otp", generateOtpObj)
        .then((res) => {
          toast.success(res.data.msg);
          setAuthToken(res.data.data.token);
          localStorage.setItem("loggedInUser", JSON.stringify(res.data));
          setGenerateOtpModal(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "There is an issue while verify the otp");
          Promise.reject(error);
        });
    } else {
      setVerifyOtpValidations(true);
      setGenerateOtpModal(true);
    }
  };

  const addBooking = async () => {
    if (simpleValidator.current.allValid()) {
      setBookingButtonDisabled(true);
      setTimeout(() => {
        setBookingButtonDisabled(false);
      }, 3000);

      // api
      //   .post("/booking/create", bookingDetails)
      //   .then((res) => {
      //     toast.success(res.data.msg);
      //     return res.data;
      //   })
      //   .catch((error) => {
      //     const errorMsg =
      //       (error &&
      //         error.response &&
      //         error.response.data &&
      //         error.response.data.error) ||
      //       (error &&
      //         error.response &&
      //         error.response.data &&
      //         error.response.data.message);
      //     toast.error(
      //       errorMsg || "There is an issue while booking the packages"
      //     );
      //     console.log(bookingDetails, bookingDetailsObj);
      //     Promise.reject(error);
      //   });
      try {
        const orderRes = await axios.post(
          `https://pmtuserapi.mequalsvps.in/payment/create-order`,
          {
            priceEnquiryNo: priceData.priceEnquiryNo,
          },
          {
            headers: {
              Authorization:
                verifiedUserData &&
                verifiedUserData !== undefined &&
                verifiedUserData.token !== undefined
                  ? `Bearer ${verifiedUserData.token}`
                  : "",
            },
          }
        );

        const { orderId, amount, currency } = orderRes.data.datum;
        console.log("orderRes.data :", orderRes.data.datum);

        const options = {
          key: "rzp_live_lRQHsZXCRAQqJ9", // Public Key
          amount,
          currency,
          name: "Plan Mi Trip",
          description: "Test Transaction",
          image: Logo1,
          order_id: orderId,
          handler: async function (response) {
            console.log(response, "response from razorpay");
            const paymentDetails = await axios
              .post(
                `https://pmtuserapi.mequalsvps.in/payment/details`,
                {
                  paymentId: response.razorpay_payment_id,
                  orderId: response.razorpay_order_id,
                },
                {
                  headers: {
                    Authorization:
                      verifiedUserData &&
                      verifiedUserData !== undefined &&
                      verifiedUserData.token !== undefined
                        ? `Bearer ${verifiedUserData.token}`
                        : "",
                  },
                }
              )
              .then((res) => {
                console.log(res.data, "response from booking");
                toast.success(res.data.msg);
                setTimeout(() => {
                  history.push({
                    pathname: `/enquiry/${
                      res.data.data && res.data.data.bookingNo
                    }`,
                    state: {
                      booking: res.data && res.data.data,
                      mode: "booking",
                    },
                  });
                }, 1100);
                localStorage.setItem("bookingStatus", res.data.data.bookingNo);
                return res.data;
              })
              .catch((error) => {
                const errorMsg =
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.error) ||
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message);
                toast.error(
                  errorMsg || "There is an issue while booking the packages"
                );
                Promise.reject(error);
              });
            console.log("paymentDetails", paymentDetails.data);
          },
          modal: {
            ondismiss: function () {
              // toast on exit
              toast.error("Payment cancelled by user.");
            },
          },
          prefill: {
            name: "User",
            email: "test@example.com",
            contact: "84877777777",
          },
          theme: {
            color: "#3399cc",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } catch (error) {
        console.error("Payment initiation failed", error);
      }
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const [timeLeft, setTimeLeft] = useState(30);
  const [isActive, setIsActive] = useState(true);
  const otpInputRef = useRef();
  //OnChange
  const onChange = (text) => {
    setOtpValue(text);
    if (text && text.length === 6) {
      otpInputRef.current?.focus();
    }
    // console.log("onChange:", text);
  };

  const sharedProps = {
    onChange,
  };
  useEffect(() => {
    let timer;
    if (isActive == true) {
      timer = setTimeout(() => {
        if (timeLeft == 0) {
          setTimeLeft(0);
          setIsActive(false);
        } else {
          setTimeLeft((prev) => prev - 1);
        }
      }, 1000);
    } else if (timeLeft === 0) {
      setIsActive(false); // Stop the timer
    }
    return () => clearTimeout(timer);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft]);

  useEffect(() => {
    if (loggedOut === "true" || loggedOut === true) {
      setTitleList([]);
      setMobile("");
      setFirstName("");
      setLastName("");
      setEmail("");
      setOtpValue("");
      setMobileValidations(false);
      localStorage.setItem("loggedOut", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedOut]);

  useEffect(() => {
    if (verifiedUserData !== undefined && verifiedUserData !== "") {
      setTitleList(
        verifiedUsers.gender
          ? {
              label: verifiedUsers.gender,
              value: verifiedUsers.gender,
            }
          : []
      );
      setMobile(verifiedUsers.mobile);
      setFirstName(verifiedUsers.firstName);
      setLastName(verifiedUsers.lastName);
      setEmail(verifiedUsers.email);
    } else {
      setTitleList([]);
      setMobile(
        packageSelectData !== undefined &&
          packageSelectData.mobileNo !== undefined
          ? packageSelectData.mobileNo
          : ""
      );
      setFirstName("");
      setLastName("");
      setOtpValue("");
      setEmail(packageSelectData !== undefined &&
          packageSelectData.email !== undefined
          ? packageSelectData.email
          : "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Traveller-details | Plan mi trip</title>
        </MetaTags>
      </div>
      <Col
        md={24}
        lg={24}
        xl={24}
        xxl={24}
        sm={24}
        xs={24}
        className={
          media == "lg" || media == "md" || media == "sm" || media == "xs"
            ? "pb-8"
            : ""
        }
      >
        <Row
          className={
            media == "sm"
              ? "pr-[6%] pl-[6%] w-[100%]"
              : media == "xs"
              ? "pr-[40px] pl-[40px] w-[100%]"
              : media == "md"
              ? "pr-[7%] pl-[7%] w-[100%] mt-[85px]"
              : media == "lg"
              ? "pr-[10%] pl-[10%] w-[100%] mt-[85px]"
              : media == "xxl"
              ? "pr-[9%] pl-[11%] w-[100%]"
              : "pr-[8%] pl-[6.5%] w-[100%]"
          }
          style={{
            overflow: "hidden",
          }}
        >
          <Col
            md={24}
            lg={18}
            xl={18}
            xxl={18}
            sm={24}
            xs={24}
            className="flex flex-col"
          >
            <Row>
              <Col
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
                className="flex flex-row mb-4"
              >
                {travellerDetailsTabs.map((data, index) => {
                  return (
                    <div
                      className={
                        travellerTabs === data.label
                          ? "text-[#eb3e43] font-semibold text-[13px] package-fonts mr-8"
                          : "mr-8 text-[13px] package-fonts"
                      }
                      onClick={() => setTravellerTabs(data.value)}
                      key={index}
                    >
                      <h1>{data.label}</h1>
                    </div>
                  );
                })}
                <div></div>
              </Col>
              <Col
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
                className="border border-1 shadow-md"
                style={{
                  borderRadius: "14px",
                }}
              >
                <Row>
                  <Col
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    className="p-4"
                  >
                    <Row>
                      <Col
                        md={7}
                        lg={7}
                        xl={7}
                        xxl={7}
                        sm={24}
                        xs={24}
                        className="mb-3"
                      >
                        <Image
                          src={packageDetailsData.imageUrl}
                          preview={false}
                          height={150}
                          width={"100%"}
                          className="border border-1 rounded-xl"
                        />
                      </Col>
                      <Col
                        md={17}
                        lg={17}
                        xl={17}
                        xxl={17}
                        sm={24}
                        xs={24}
                        className="mb-3 pl-7"
                      >
                        <div className="border border-b-1 border-x-0 border-t-0 pb-2">
                          <h1 className="text-start package-fonts text-[12px]">
                            Package Detail
                          </h1>
                          <h1 className="text-start font-semibold package-fonts text-[20px] mb-2">
                            {packageDetailsData
                              ? packageDetailsData.packageName
                              : ""}
                          </h1>
                          <h1 className="text-start text-[13px] package-fonts mb-2">
                            <ClockCircleOutlined className="text-[16px] mr-1" />
                            {packageDetailsData
                              ? "Duration: " +
                                packageDetailsData.nights +
                                " / " +
                                packageDetailsData.days
                              : ""}
                          </h1>
                          <h1 className="text-start text-[13px] package-fonts mb-2">
                            <UsergroupAddOutlined className="text-[16px] mr-1" />
                            {packageDetailsData && priceData.totalMembersInRoom
                              ? "No of Person: " + priceData.totalMembersInRoom
                              : ""}
                          </h1>
                          <div className="flex">
                            <h1 className="text-start text-[13px] package-fonts mb-2">
                              <CalendarOutlined className="text-[16px] mr-1" />
                              {packageDetailsData
                                ? "Start Date: " + startDate
                                : ""}
                            </h1>
                            <h1 className="text-start ml-3 text-[13px] package-fonts mb-2">
                              <CalendarOutlined className="text-[16px] mr-1" />
                              {packageDetailsData ? "End Date: " + endDate : ""}
                            </h1>
                          </div>
                        </div>
                        <div>
                          <div
                            className={
                              "flex w-[100%] pl-3 mt-3 pb-6 border-x-0 border-t-0"
                            }
                          >
                            {packageDetailsData.hotels === true ? (
                              <div className="pr-3">
                                <FaHotel className="text-center text-[18px] w-[100%]" />
                              </div>
                            ) : (
                              ""
                            )}
                            {packageDetailsData.sightSeeing === true ? (
                              <div className="pr-3">
                                <PiBinocularsBold className="text-center text-[18px] w-[100%]" />
                              </div>
                            ) : (
                              ""
                            )}
                            {packageDetailsData.transport === true ? (
                              <div className="pr-3">
                                <IoCarSportSharp className="text-center text-[18px] w-[100%]" />
                              </div>
                            ) : (
                              ""
                            )}
                            {packageDetailsData.meals === true ? (
                              <div className="pr-3">
                                <GiHotMeal className="text-center text-[18px] w-[100%]" />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    className="bg-[#e74c3c3b] pb-4"
                    style={{
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                    }}
                  >
                    <Row>
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <div className="w-[100%] p-2 mt-3">
                          <div className="w-[100%] flex pb-1">
                            <h1 className="text-[14px] package-fonts font-semibold">
                              Inclusions
                            </h1>
                          </div>
                          <div className="ml-1 mt-1">
                            {packageDetailsData &&
                            packageDetailsData.inclusion.length > 0
                              ? packageDetailsData.inclusion.map(
                                  (data, index) => {
                                    return (
                                      <div key={index} className="mb-1 flex">
                                        <p>
                                          <CheckOutlined className="text-[green] text-[12px]" />
                                        </p>
                                        <h1 className="text-[12px] ml-2 mt-[2px]">
                                          {data}
                                        </h1>
                                      </div>
                                    );
                                  }
                                )
                              : ""}
                          </div>
                        </div>
                      </Col>
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <div className="w-[100%] p-2 mt-1 pb-2">
                          <div
                            className="w-[100%] flex pb-1"
                            style={{
                              borderTop: "1px solid gray",
                              borderStyle: "dashed",
                            }}
                          >
                            <h1 className="text-[14px] mt-3 package-fonts font-semibold">
                              Exclusions
                            </h1>
                          </div>
                          <div className="ml-1 mt-1">
                            {packageDetailsData &&
                            packageDetailsData.exclusion.length > 0
                              ? packageDetailsData.exclusion.map(
                                  (data, index) => {
                                    return (
                                      <div key={index} className="mb-1 flex">
                                        <p>
                                          <CloseOutlined className="text-[#eb3e43] text-[12px]" />
                                        </p>
                                        <h1 className="text-[12px] ml-2 mt-[2px]">
                                          {data}
                                        </h1>
                                      </div>
                                    );
                                  }
                                )
                              : ""}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col
                className="border border-1 shadow-md mt-[55px]"
                style={{
                  borderRadius: "14px",
                }}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
              >
                <div
                  className="p-3 w-[100%] bg-[#ffd1d1] flex"
                  style={{
                    borderTopRightRadius: "16px",
                    borderTopLeftRadius: "16px",
                  }}
                >
                  <h1
                    style={{
                      border: "1px solid black",
                      borderRadius: "40px",
                      padding: "1px 10px",
                    }}
                    className="text-start font-semibold text-[18px]"
                  >
                    ₹
                  </h1>
                  <h1 className="ml-2 mt-[2px] text-start font-semibold package-fonts text-[16px]">
                    Traveller Details
                  </h1>
                </div>

                <Row className="p-5">
                  <Col
                    md={4}
                    sm={24}
                    xs={24}
                    lg={4}
                    xl={4}
                    xxl={4}
                    className="pr-3 mt-3"
                  >
                    <Select
                      value={titleList}
                      onChange={(e, options) => {
                        setTitleList({
                          label: options.label,
                          value: e,
                        });
                      }}
                      options={[
                        {
                          label: "Mr",
                          value: "Mr",
                        },
                        {
                          label: "Mrs",
                          value: "Mrs",
                        },
                        {
                          label: "Ms",
                          value: "Ms",
                        },
                      ]}
                      dropdownRender={(menu) => (
                        <>
                          <p className="bg-[#f1f1f1] p-1 rounded-md text-center input-label">
                            Please Select
                          </p>
                          <Divider
                            style={{
                              margin: "8px 0",
                            }}
                          />
                          <p className="input-label"> {menu}</p>
                        </>
                      )}
                      className="input-label w-[100%] h-[35px]"
                      placeholder="Select title"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        borderRadius: "6px",
                        border: "1px solid #cfcfcfe0",
                      }}
                      variant={false}
                    />
                    <p
                      style={{
                        display: "inline-block",
                      }}
                      className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                    >
                      {otpGenerateValidations &&
                      titleList &&
                      titleList.length === 0
                        ? "The title list field is required"
                        : simpleValidator.current.message(
                            "titleList",
                            titleList && titleList.value,
                            "required"
                          )}
                    </p>
                  </Col>
                  <Col
                    md={10}
                    sm={24}
                    xs={24}
                    lg={10}
                    xl={10}
                    xxl={10}
                    className="pr-3 mt-3"
                  >
                    <Input
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                      className="input-label w-[100%] h-[35px]"
                      placeholder="Enter first name"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        borderRadius: "6px",
                        border: "1px solid #cfcfcfe0",
                      }}
                      variant={false}
                    />
                    <p
                      style={{
                        display: "inline-block",
                      }}
                      className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                    >
                      {otpGenerateValidations && firstName === ""
                        ? "The first name field is required"
                        : simpleValidator.current.message(
                            "firstName",
                            firstName,
                            "required"
                          )}
                    </p>
                  </Col>
                  <Col
                    md={10}
                    sm={24}
                    xs={24}
                    lg={10}
                    xl={10}
                    xxl={10}
                    className="pr-3 mt-3"
                  >
                    <Input
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                      }}
                      className="input-label w-[100%] h-[35px]"
                      placeholder="Enter last name"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        borderRadius: "6px",
                        border: "1px solid #cfcfcfe0",
                      }}
                      variant={false}
                    />
                    <p
                      style={{
                        display: "inline-block",
                      }}
                      className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                    >
                      {simpleValidator.current.message(
                        "lastName",
                        lastName,
                        "required"
                      )}
                    </p>
                  </Col>
                </Row>

                <Row className="pl-5 pr-5 pb-1 border border-t-1 border-x-0 border-b-0 pt-5">
                  <Col
                    md={10}
                    sm={24}
                    xs={24}
                    lg={10}
                    xl={10}
                    xxl={10}
                    className={
                      media === "sm" || media === "xs" ? "mt-3 pr-3" : ""
                    }
                  >
                    <Input
                      className="w-[100%] h-[35px]"
                      name="mobile"
                      value={mobile}
                      onChange={validationChange}
                      placeholder="Mobile"
                      id="main-input"
                      maxLength={10}
                      prefix={"+91"}
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        borderRadius: "6px",
                        border: "1px solid #cfcfcfe0",
                      }}
                      variant={false}
                    />
                    <div
                      onClick={() => {
                        setOtpValue("");
                        generateOtpDetails();
                      }}
                      className={
                        generateBtnDisabled
                          ? "pointer-events-none opacity-1 mt-2 w-[30%] p-[2px] rounded-md cursor-pointer hover:bg-[red] package-fonts text-center text-[12px] bg-[#ef2c31ba] text-[white]"
                          : "mt-2 w-[30%] p-[2px] rounded-md cursor-pointer hover:bg-[red] package-fonts text-center text-[12px] bg-[#eb3e43] text-[white]"
                      }
                    >
                      Generate OTP
                    </div>
                    <div
                      id="error-panel"
                      style={{
                        // display: "none",
                        // marginTop: "-15px",
                        marginBottom: "10px",
                      }}
                    >
                      {mobileValidations == true &&
                      otpGenerateValidations === false ? (
                        <p className="input-label text-[11px] text-start text-[#ff0000]">
                          The mobile field is not valid
                        </p>
                      ) : otpGenerateValidations && mobile === "" ? (
                        <p className="input-label text-[11px] text-start text-[#ff0000]">
                          The mobile field is required
                        </p>
                      ) : (
                        <p
                          style={{
                            display: "inline-block",
                          }}
                          className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                        >
                          {simpleValidator.current.message(
                            "mobile",
                            mobile,
                            "required"
                          )}
                        </p>
                      )}
                    </div>
                  </Col>
                  <Col
                    md={10}
                    sm={24}
                    xs={24}
                    lg={10}
                    xl={10}
                    xxl={10}
                    className={
                      media === "sm" || media === "xs"
                        ? "pl-0 pr-3 mt-3"
                        : "pl-3"
                    }
                  >
                    <Input
                      className="w-[100%] h-[35px]"
                      name="email"
                      value={email}
                      onChange={validationEmailChange}
                      placeholder="Email"
                      id="main-email-input"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        borderRadius: "6px",
                        border: "1px solid #cfcfcfe0",
                      }}
                      variant={false}
                    />
                    <div
                      id="error-email-panel"
                      style={{
                        // display: "none",
                        // marginTop: "-15px",
                        marginBottom: "10px",
                      }}
                    >
                      {emailValidations == true ? (
                        <p className="input-label text-[11px] text-start text-[#ff0000]">
                          The email field is not valid
                        </p>
                      ) : (
                        <p
                          style={{
                            display: "inline-block",
                          }}
                          className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                        >
                          {simpleValidator.current.message(
                            "email",
                            email,
                            "required"
                          )}
                        </p>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="pl-5 pr-5 pb-2">
                  <Col
                    md={24}
                    sm={24}
                    xs={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    className=""
                  >
                    <div className="input-label text-[12px] text-[gray]">
                      Your booking details will be sent to this email address
                      and mobile number.
                    </div>
                  </Col>
                  <Col
                    md={24}
                    sm={24}
                    xs={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    className="mt-3 mb-3"
                  >
                    <div
                      onClick={() => setGstOpen(!gstOpen)}
                      className="cursor-pointer w-[100%] input-label text-[14px]"
                    >
                      {gstOpen ? "(-)" : "(+)"} GST Details{" "}
                      <span className="text-[gray] text-[12px]">
                        (optional)
                      </span>
                    </div>
                    {gstOpen ? (
                      <Row className="pb-1 pt-1">
                        <Col
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          className="mt-2 pr-3"
                        >
                          <Typography className="package-fonts text-[14px] mb-2">
                            Mobile
                          </Typography>
                          <Input
                            name="customerMobile"
                            value={customerMobile}
                            id="main-enquire-input"
                            onChange={validationEnquireChange}
                            style={{
                              height: "40px",
                              fontFamily: "Poppins",
                            }}
                            maxLength={10}
                            placeholder="Your Mobile"
                            className="package-fonts text-[14px]"
                          />
                          <div id="error-enquire-panel">
                            {customerMobileValidations == true ? (
                              <p className="input-label text-[11px] text-start text-[#ff0000]">
                                The mobile field is not valid
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          className="mt-2 pr-3"
                        >
                          <Typography className="package-fonts text-[14px] mb-2">
                            Email ID
                          </Typography>
                          <Input
                            name="customerMail"
                            value={customerMail}
                            style={{
                              height: "40px",
                              fontFamily: "Poppins",
                            }}
                            onChange={validationEnquireEmailChange}
                            placeholder="Enter Email ID"
                            id="main-enquire-email-input"
                            className="package-fonts text-[14px]"
                          />
                          <div id="error-enquire-email-panel">
                            {customerEmailValidations == true ? (
                              <p className="input-label text-[11px] text-start text-[#ff0000]">
                                The email field is not valid
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          className="mt-2 pr-3"
                        >
                          <Typography className="package-fonts text-[14px] mb-2">
                            GST No
                          </Typography>
                          <Input
                            name="gstNo"
                            value={gstNo}
                            style={{
                              height: "40px",
                              fontFamily: "Poppins",
                            }}
                            onChange={(e) => setGstNo(e.target.value)}
                            placeholder="Enter gst no"
                            className="package-fonts text-[14px]"
                          />
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          className="mt-2 pr-3"
                        >
                          <Typography className="package-fonts text-[14px] mb-2">
                            Company Name
                          </Typography>
                          <Input
                            name="companyName"
                            value={companyName}
                            style={{
                              height: "40px",
                              fontFamily: "Poppins",
                            }}
                            onChange={(e) => setCompanyName(e.target.value)}
                            placeholder="Enter company name"
                            className="package-fonts text-[14px]"
                          />

                          {/* <p
                            style={{
                              display: "inline-block",
                            }}
                            className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                          >
                            {enquireValidations === true && customerMail === ""
                              ? "the company field is required"
                              : ""}
                          </p> */}
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          className=""
                        >
                          <Typography className="package-fonts text-[14px] mb-2">
                            Address
                          </Typography>
                          <Input.TextArea
                            name="address"
                            value={address}
                            style={{
                              height: "60px",
                              fontFamily: "Poppins",
                            }}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="Enter address"
                            id="main-enquire-email-input"
                            className="package-fonts text-[14px] h-[60px]"
                          />

                          {/* <p
                            style={{
                              display: "inline-block",
                            }}
                            className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                          >
                            {enquireValidations === true && customerMail === ""
                              ? "the address field is required"
                              : ""}
                          </p> */}
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col
                    md={24}
                    sm={24}
                    xs={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    className=""
                  >
                    <div className="flex package-fonts mt-1 mb-2">
                      <Checkbox
                        checked={policyAccept}
                        onChange={(e) => setPolicyAccept(e.target.checked)}
                        className="hover:text-[#eb3e43] hover:border-[#eb3e43]"
                      />
                      <p className="text-[13px] ml-1 mr-1">
                        I understand and agree to the rules of this fare, and
                        the &{" "}
                        <span className="underline text-[#eb3e43] mr-2">
                          Terms & Conditions
                        </span>
                        <span>of PlanMiTrip</span>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
                className={
                  media === "sm" || media === "xs"
                    ? "flex"
                    : "flex justify-center"
                }
              >
                <div
                  className={
                    media === "sm" || media === "xs"
                      ? "mt-5 w-[100%] bg-[#eb3e43] hover:bg-[red] text-center text-[14px] leading-loose track-wider mt-1"
                      : "mt-5 w-[60%] bg-[#eb3e43] hover:bg-[red] text-center text-[14px] leading-loose track-wider mt-1"
                  }
                  style={{
                    borderRadius: "25px",
                    border: "1px solid #eb3e43",
                    // padding: "4px 20px",
                    fontFamily: "Poppins",
                    padding: "5px 22px",
                    color: "#ffffff",
                    cursor: "pointer",
                    pointerEvents: bookingButtonDisabled ? "none" : "",
                    opacity: bookingButtonDisabled ? 1 : "false",
                  }}
                  onClick={() => {
                    // history.push({
                    //   pathname: `/`,
                    // });
                    addBooking();
                  }}
                >
                  <h1 className="">
                    {bookingButtonDisabled ? (
                      <p className="flex text-[white]">
                        {" "}
                        <Spin className="mr-1" /> Processing
                      </p>
                    ) : (
                      "Continue Booking"
                    )}
                  </h1>
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            md={24}
            lg={6}
            xl={6}
            xxl={6}
            sm={24}
            xs={24}
            className={
              media === "md" || media === "sm" || media === "xs" ? "" : "pl-5"
            }
          >
            <Row>
              <Col
                className="border border-1 shadow-md mt-[35px]"
                style={{
                  borderRadius: "14px",
                }}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
              >
                <div
                  className="p-3 w-[100%] bg-[#ffd1d1] flex"
                  style={{
                    borderTopRightRadius: "16px",
                    borderTopLeftRadius: "16px",
                  }}
                >
                  <h1
                    style={{
                      border: "1px solid black",
                      borderRadius: "40px",
                      padding: "1px 10px",
                    }}
                    className="text-start font-semibold text-[18px]"
                  >
                    ₹
                  </h1>
                  <h1 className="ml-2 mt-[2px] text-start font-semibold package-fonts text-[16px]">
                    Price Details
                  </h1>
                </div>
                <div className="p-3 w-[100%] flex justify-between border border-b-1 border-x-0 border-t-0 pb-2">
                  <h1 className="text-start package-fonts text-[13px]">
                    {priceData.membersTypeString} *{" "}
                    {priceData.totalMembersInRoom}
                  </h1>
                  <h1 className="text-start font-semibold  text-[16px]">
                    ₹{" "}
                    <span className="package-fonts font-semibold  text-[16px]">
                      {priceData && priceData.packagePrice
                        ? priceData.packagePrice
                        : 0}
                    </span>
                  </h1>
                </div>
                <div className="p-3 w-[100%] flex justify-between border border-b-1 border-x-0 border-t-0 pb-2">
                  <h1 className="text-start package-fonts text-[13px]">Tax</h1>
                  <h1 className="text-start font-semibold  text-[16px]">
                    ₹{" "}
                    <span className="package-fonts font-semibold  text-[16px]">
                      {priceData && priceData.taxAmount
                        ? priceData.taxAmount
                        : 0}
                    </span>
                  </h1>
                </div>

                {couponAppliedData !== "" ? (
                  <div className="p-3 w-[100%] flex justify-between border border-b-1 border-x-0 border-t-0 pb-2">
                    <h1 className="text-start package-fonts text-[13px]">
                      Discount (Coupon)
                    </h1>
                    <h1 className="text-start font-semibold  text-[16px]">
                      ₹{" "}
                      <span className="package-fonts font-semibold  text-[16px]">
                        {couponAppliedData
                          ? parseFloat(couponAppliedData).toFixed(2)
                          : 0}
                      </span>
                    </h1>
                  </div>
                ) : (
                  ""
                )}

                <div className="pl-3 pr-3 pt-3 pb-4 w-[100%] text-[#eb3e43] flex justify-between border border-b-1 border-x-0 border-t-0 pb-2">
                  <h1 className="text-start font-semibold package-fonts text-[16px]">
                    Grand Total
                  </h1>
                  <div></div>
                  <h1 className="text-start font-semibold  text-[16px]">
                    ₹{" "}
                    <span className="package-fonts font-semibold  text-[16px]">
                      {grandTotal !== undefined && grandTotal !== ""
                        ? grandTotal.toFixed(2)
                        : 0}
                    </span>
                  </h1>
                </div>
              </Col>
              <Col
                className="border border-1 shadow-md mt-[15px]"
                style={{
                  borderRadius: "14px",
                }}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
              >
                <Row>
                  <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                    {" "}
                    <div
                      className="p-2 w-[100%] flex bg-[#eb3e43]"
                      style={{
                        borderTopRightRadius: "16px",
                        borderTopLeftRadius: "16px",
                      }}
                    >
                      <h1 className="ml-2 mt-[2px] text-[white] text-start font-semibold package-fonts text-[14px]">
                        Have a coupon code ?
                      </h1>
                    </div>
                  </Col>
                  <Col
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    className="p-3"
                  >
                    <Row>
                      <Col md={16} lg={16} xl={16} xxl={16} sm={24} xs={24}>
                        <Input
                          variant={false}
                          className="w-[100%] package-fonts mt-2"
                          placeholder="Enter Coupon Code"
                          name="couponCode"
                          value={couponCode}
                          disabled={couponAppliedData !== "" ? true : false}
                          onChange={(e) => setCouponCode(e.target.value)}
                        />
                        <p className="border border-t-1 border-x-0 border-b-0">
                          {""}
                        </p>
                        {couponValidations === true && couponCode === "" ? (
                          <p
                            style={{
                              display: "inline-block",
                            }}
                            className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                          >
                            the coupon field is required
                          </p>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col
                        md={8}
                        lg={8}
                        xl={8}
                        xxl={8}
                        sm={24}
                        xs={24}
                        className={couponAppliedData !== "" ? "pl-3" : "pl-5"}
                      >
                        <div
                          className={
                            couponAppliedData !== ""
                              ? "w-[100%] mt-1 bg-[#cb2126ad] hover:bg-[red] text-center text-[14px] leading-loose track-wider mt-1"
                              : "w-[90%] mt-1 bg-[#eb3e43] hover:bg-[red] text-center text-[14px] leading-loose track-wider mt-1"
                          }
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #eb3e43",
                            // padding: "4px 20px",
                            fontFamily: "Poppins",
                            padding: "2px 8px",
                            color: "#ffffff",
                            cursor: "pointer",
                            pointerEvents:
                              couponButtonDisabled || couponAppliedData !== ""
                                ? "none"
                                : "",
                            opacity:
                              couponButtonDisabled || couponAppliedData !== ""
                                ? 1
                                : "",
                          }}
                          onClick={() => {
                            addCouponApply();
                          }}
                        >
                          {couponAppliedData !== "" ? "Applied" : "Apply"}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
                className="border border-1 shadow-md mt-[15px]"
                style={{
                  borderRadius: "14px",
                }}
              >
                {" "}
                <div
                  className="p-2 w-[100%] flex bg-[#eb3e43]"
                  style={{
                    borderTopRightRadius: "16px",
                    borderTopLeftRadius: "16px",
                  }}
                >
                  <h1 className="ml-2 mt-[2px] text-[white] text-start font-semibold package-fonts text-[14px]">
                    Reward Points
                  </h1>
                </div>
                <div className="p-2 w-[100%] flex justify-between">
                  <h1 className="ml-2 mt-[2px] text-start font-semibold package-fonts text-[13px]">
                    Available Reward points:
                  </h1>
                  <p className="package-fonts">
                    {verifiedUserData &&
                    verifiedUserData &&
                    verifiedUserData.rewardPoint !== undefined
                      ? verifiedUserData.rewardPoint
                      : 0}
                  </p>
                </div>
              </Col>
              <Col
                className="border border-1 shadow-md mt-[15px]"
                style={{
                  borderRadius: "14px",
                }}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                sm={24}
                xs={24}
              >
                <div
                  className="p-3 w-[100%] bg-[#ffd1d1] flex"
                  style={{
                    borderTopRightRadius: "16px",
                    borderTopLeftRadius: "16px",
                  }}
                >
                  <h1
                    style={{
                      border: "1px solid black",
                      borderRadius: "40px",
                      padding: "1px 10px",
                    }}
                    className="text-start font-semibold text-[18px]"
                  >
                    ₹
                  </h1>
                  <h1 className="ml-2 mt-[2px] text-start font-semibold package-fonts text-[16px]">
                    Pay Now
                  </h1>
                </div>
                <div className="p-3 w-[100%] flex justify-between border border-b-1 border-x-0 border-t-0 pb-2">
                  <div className="flex">
                    <Radio.Group
                      onChange={(e) => setMakePayment(e.target.value)}
                      value={makePayment}
                    >
                      <div className="flex">
                        <Radio value={"fullPayment"} />
                        <h1 className="ml-[1px] mt-[2px] text-start package-fonts font-semibold text-[12px]">
                          Make full payment now
                        </h1>
                      </div>
                    </Radio.Group>
                  </div>
                  <h1 className="text-start text-[16px]">
                    ₹{" "}
                    <span className="package-fonts font-semibold  text-[14px]">
                      {grandTotal !== undefined &&
                      grandTotal !== null &&
                      grandTotal !== ""
                        ? grandTotal.toFixed(2)
                        : 0}
                    </span>
                  </h1>
                </div>
              </Col>
              <div
                className={
                  "mt-5 w-[100%] bg-[#eb3e43] hover:bg-[red] text-center text-[14px] leading-loose track-wider mt-1"
                }
                style={{
                  borderRadius: "25px",
                  border: "1px solid #eb3e43",
                  // padding: "4px 20px",
                  fontFamily: "Poppins",
                  padding: "5px 22px",
                  color: "#ffffff",
                  cursor: "pointer",
                  pointerEvents: bookingButtonDisabled ? "none" : "",
                  opacity: bookingButtonDisabled ? 1 : "false",
                }}
                onClick={() => {
                  // history.push({
                  //   pathname: `/`,
                  // });
                  addBooking();
                }}
              >
                <h1 className="">
                  {bookingButtonDisabled ? (
                    <p className="flex text-[white]">
                      {" "}
                      <Spin className="mr-1" /> Processing
                    </p>
                  ) : (
                    "Continue Booking"
                  )}
                </h1>
              </div>
            </Row>
          </Col>
        </Row>
        {/* Enquire modal */}
        <Modal
          open={generateOtpModal}
          // title="Want to Go For A Memorable Holiday?"
          maskClosable={false}
          // onClose={() => setVerifyBtnDisabled(false)}
          closable
          onOk={() => verifyOtpDetails()}
          onCancel={() => setVerifyBtnDisabled(false)}
          okButtonProps={{
            disabled: verifyBtnDisabled ? true : false,
          }}
          footer={null}
          className="package-fonts mt-[40px] pr-0"
          closeIcon
          width={400}
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} className="">
            <Row className="">
              <Col
                md={24}
                sm={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-[-6px] package-fonts text-[18px] font-semibold"
              >
                Generate OTP
              </Col>
            </Row>
            <Row className="w-[113.5%] mt-2 ml-[-24px] border border-b-1 border-x-0 border-t-0"></Row>
            <Row className="">
              <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
                {/* {isActive ? ( */}
                <div className="ml-2 mt-3 w-[100%]">
                  <div className="mt-5 w-[100%] flex justify-center">
                    <Title level={6}></Title>
                    <Input.OTP
                      value={otpValue}
                      formatter={(str) => str.toUpperCase()}
                      {...sharedProps}
                      className="package-fonts"
                    />
                    <p
                      style={{
                        display: "inline-block",
                      }}
                      className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                    >
                      {otpValue === "" && verifyOtpValidations == true
                        ? "The otp field is required"
                        : ""}
                    </p>
                  </div>{" "}
                </div>
                {/* ) : (
                  ""
                )} */}
                {isActive ? (
                  <p className="package-fonts text-center text-sm text-[red] mt-1">
                    Resend OTP in {timeLeft}s
                  </p>
                ) : (
                  <div className="flex justify-center mt-2">
                    <button
                      onClick={generateOtpDetails}
                      className="package-fonts text-center text-[#eb3e43] underline"
                    >
                      Resend OTP
                    </button>
                  </div>
                )}
              </Col>
            </Row>
            <Row className="w-[113.5%] mt-[50px] ml-[-24px] border border-b-1 border-x-0 border-t-0"></Row>
            <Row className="mt-4">
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="flex justify-end"
              >
                <div
                  style={{
                    borderRadius: "4px",
                    pointerEvents: verifyBtnDisabled ? "none" : "",
                    opacity: verifyBtnDisabled ? 1 : "",
                  }}
                  onClick={() => {
                    setGenerateOtpModal(false);
                  }}
                  className="mr-3 cursor-pointer pl-4 pr-4 pt-1 pb-1 package-fonts border border-1 text-center text-[12px] bg-[white] hover:bg-[lightgray]"
                >
                  <h1 className="">Cancel</h1>
                </div>
                <div
                  style={{
                    borderRadius: "4px",
                    pointerEvents: verifyBtnDisabled ? "none" : "",
                    opacity: verifyBtnDisabled ? 1 : "",
                  }}
                  ref={otpInputRef}
                  onClick={() => {
                    verifyOtpDetails();
                  }}
                  className="cursor-pointer pl-4 pr-4 pt-1 pb-1 package-fonts text-center text-[12px] bg-[#eb3e43] hover:bg-[red] text-[white]"
                >
                  {/* {loginLoading ? (
                    <p className="package-fonts">Loading</p>
                  ) : ( */}
                  <h1 className="">Verify OTP</h1>
                  {/* )} */}
                </div>
              </Col>
            </Row>
          </Col>
        </Modal>
      </Col>
    </React.Fragment>
  );
};

TravellerDetails.propTypes = {
  location: PropTypes.any,
};

export default withRouter(TravellerDetails);
